module.exports = __webpack_public_path__ + "img/settings-icon.bcbfb6a7.svg";